// extracted by mini-css-extract-plugin
module.exports = {"confrimBtn":"Button_confrimBtn__3Or3i","whiteButton":"Button_whiteButton__3LVXx","buy":"Button_buy__1SMc3","borderRed":"Button_borderRed__1EXks"};